import { Check, X } from 'lucide-react';

const ResultScreen = ({ result, onNewVerification }) => {
  const isSuccess = result?.success === true;
  const faceMatchData = result?.data?.faceMatch;
  const ocrData = result?.data?.ocrData;
  const ecValidation = faceMatchData?.ecValidation;
  const faceMatched = faceMatchData?.faceMatched;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="card text-center">
        {isSuccess ? (
          <>
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Check size={40} className="text-green-500" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Verification Successful!</h2>
            <p className="text-gray-600 mb-6">Your identity has been verified successfully</p>
          </>
        ) : (
          <>
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <X size={40} className="text-red-500" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Verification Failed</h2>
            <p className="text-gray-600 mb-6">Verification process encountered an error</p>
          </>
        )}

        <div className="text-left bg-gray-50 rounded-lg p-6 mb-6">
          <h3 className="font-semibold text-gray-800 mb-4">Verification Details</h3>

          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Transaction ID:</span>
              <span className="font-medium">{faceMatchData?.transactionId || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Timestamp:</span>
              <span className="font-medium">{faceMatchData?.timeStamp || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Name (English):</span>
              <span className="font-medium">{ocrData?.nameEnglish || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Name (Bangla):</span>
              <span className="font-medium">{ocrData?.nameBangla || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Father's Name:</span>
              <span className="font-medium">{ocrData?.fatherName || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Mother's Name:</span>
              <span className="font-medium">{ocrData?.motherName || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">NID Number:</span>
              <span className="font-medium">{ocrData?.nidNumber || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Date of Birth:</span>
              <span className="font-medium">{ocrData?.dateOfBirth || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Address:</span>
              <span className="font-medium text-right max-w-xs">{ocrData?.address || 'N/A'}</span>
            </div>

            {/* EC Validation Details */}
            {ecValidation && (
              <>
                <div className="border-t border-gray-200 pt-2 mt-2">
                  <div className="font-semibold text-gray-800 mb-2">EC Validation</div>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">NID Matched:</span>
                  <span className={`font-medium ${ecValidation?.nidMatched ? 'text-green-600' : 'text-red-600'}`}>
                    {ecValidation?.nidMatched ? '✓ Yes' : '✗ No'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">DOB Matched:</span>
                  <span className={`font-medium ${ecValidation?.dobMatched ? 'text-green-600' : 'text-red-600'}`}>
                    {ecValidation?.dobMatched ? '✓ Yes' : '✗ No'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Name Matched:</span>
                  <span className={`font-medium ${ecValidation?.nameMatched ? 'text-green-600' : 'text-red-600'}`}>
                    {ecValidation?.nameMatched ? '✓ Yes' : '✗ No'}
                  </span>
                </div>
              </>
            )}

            <div className="flex justify-between">
              <span className="text-gray-600">Face Matched:</span>
              <span className={`font-medium ${faceMatched ? 'text-green-600' : 'text-red-600'}`}>
                {faceMatched ? '✓ Yes' : '✗ No'}
              </span>
            </div>
          </div>
        </div>

        <button
          onClick={onNewVerification}
          className="btn-primary w-full"
        >
          Start New Verification
        </button>
      </div>
    </div>
  );
};

export default ResultScreen;
